import { useTranslation } from "react-i18next";
import "../style.css";
import logoAA  from "~/assets/logo/logoAA.png";
import logoBS  from "~/assets/logo/logoBS.png";
import logoGLS from "~/assets/logo/logoGLS.png";
import logoMS  from "~/assets/logo/logoMS.png";
import logoQT  from "~/assets/logo/logoQT.png";
import logoGL  from "~/assets/logo/logoGL.png";
import logoHA  from "~/assets/logo/logoHA.png";
import logoHH  from "~/assets/logo/logoHH.png";
import logoNT  from "~/assets/logo/logoNT.png";
import logoVCT from "~/assets/logo/logoVCT.png";
import logoCF  from "~/assets/logo/logoCF.jpg";
import logoKT  from "~/assets/logo/logoKT.png";

const partners = [
  { name: "AA Corporation",      logo: logoAA,   link: "https://aacorporation.com/" },
  { name: "Bulsan",              logo: logoBS,   link: "https://bulsan.vn/" },
  { name: "Gạch lót nền",        logo: logoGLS,  link: "https://www.gachlotnen.com/" },
  { name: "Masan",               logo: logoMS,   link: "https://www.masangroup.com/" },
  { name: "Vạn Công Thành",      logo: logoVCT,  link: "https://www.vancongthanh.com/" },
  { name: "Nhà trọ sạch sẽ",     logo: logoNT,   link: "https://www.nhatrosachse.com/" },
  { name: "Quốc Thịnh",          logo: logoQT,   link: "https://quocthinh.com.vn/" },
  { name: "Greenleaf",           logo: logoGL,   link: "https://greenleafvietnam.com/" },
  { name: "Hội An",              logo: logoHA,   link: "https://hoiango.com/" },
  { name: "Hoàng Hà Bình Phước", logo: logoHH,   link: "https://www.hoanghabp.com/" },
  { name: "Americano Coffee",    logo: logoCF,   link: "https://www.americano-coffee.com/" },
  { name: "Kim Tín Group",       logo: logoKT,   link: "https://kimtingroup.com/" },
];

/* Duplicate 3× để đảm bảo track đủ rộng cho mọi kích thước màn hình */
const trackItems = [...partners, ...partners, ...partners];

const PartnerSection = () => {
  const { t } = useTranslation('home');

  return (
    <section className="dev-partners-section">
      <div className="dev-partners-inner">
        <div className="dev-section-label-wrapper">
          <span className="dev-section-comment">{t('partners.label')}</span>
        </div>
        <h2 className="dev-section-h2">{t('partners.title')}</h2>
        <p className="dev-partners-subtitle">
          {t('partners.subtitle')}
        </p>
      </div>

      {/* Marquee */}
      <div className="dev-marquee-wrapper">
        <div className="dev-marquee-fade dev-marquee-fade-left" />
        <div className="dev-marquee-fade dev-marquee-fade-right" />

        <div className="dev-marquee-track">
          {trackItems.map((p, i) => (
            <a
              key={i}
              href={p.link}
              target="_blank"
              rel="noopener noreferrer"
              className="dev-partner-chip"
            >
              <img src={p.logo} alt={p.name} className="dev-partner-logo" />
              <span className="dev-partner-name">{p.name}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerSection;
